<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="filteredPayRanges"
      @onActionClick="viewState.state.showPayRangeModal.show = true"
      @onSearch="viewState.state.filters.searchText = $event"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      :emptyObjectData="emptyObjectData"
      @removeAllFilters="viewState.state.filters.values = []"
      :draggable="true"
      @onDrag="onDrag"
    >
      <template #Dropdown-activator>
        <div class="icon-container">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-svg"
          >
            <path
              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
              stroke="#344054"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
              stroke="#344054"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
              stroke="#344054"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </template>
    </UniversalTable>
    <PayRangeModal
      @closeAddDialog="viewState.state.showPayRangeModal.show = false"
      :showDialog="viewState.state.showPayRangeModal.show"
    />
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="viewState.state.filters.statusOptions"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
  </v-container>
</template>

<script setup>
import { onMounted, getCurrentInstance, computed, ref } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "./composables/useTableConfig";
import { usePayRangeViewState } from "./composables/usePayRangeViewState";
import PayRangeModal from "@components/PayRangeModal/PayRangeModal.vue";
import SearchModal from "@components/SearchBar/SearchModal.vue";
const app = getCurrentInstance();
const { proxy } = app;

const tableConfig = useTableConfig();
const viewState = usePayRangeViewState();
const emptyObjectData = {
  singular: "Pay Range",
  plural: "Pay Ranges",
};

const payRanges = ref([
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 1,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 2,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 3,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 4,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 5,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 6,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 7,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 8,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 9,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 10,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 11,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 12,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/us.svg",
      location: "New York",
      name: "A-12-HR Mid",
      pay_range_expressed_as: "per_hour",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_hour",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 15,
    status: "draft",
    order: 13,
  },
  {
    pay_range_header: {
      country_flag: "https://flagcdn.com/fr.svg",
      location: "Paris",
      name: "A-12-HR Expert",
      pay_range_expressed_as: "per_year",
      pay_range_currency_code: "GBP",
    },
    pay_range_line: {
      expressed: "per_year",
      zeroPenetration: 100,
      oneThirdPenetration: 1000,
      twoThirdPenetration: 1010,
      fullPenetration: 1400,
    },
    used: 10,
    status: "active",
    order: 14,
  },
]);

const filteredPayRanges = computed(() => {
  let payRangeList = [...payRanges.value];

  if (
    viewState.state.filters.searchText &&
    viewState.state.filters.searchText.length > 0
  ) {
    const searchText = viewState.state.filters.searchText.toLowerCase();

    payRangeList = payRangeList.filter((el) => {
      const fullName =
        `${el?.pay_range_header.name} ${el.pay_range_header.location}`.toLowerCase();
      return (
        fullName.includes(searchText) ||
        el?.pay_range_header.name.toLowerCase().includes(searchText) ||
        el.pay_range_header.location.toLowerCase().includes(searchText)
      );
    });
  }

  if (
    viewState.state.filters.values.some((val) =>
      viewState.state.filters.statusOptions.includes(val)
    )
  ) {
    payRangeList = payRangeList.filter((el2) =>
      viewState.state.filters.values.includes(el2.status)
    );
  }

  return payRangeList;
});

function onDrag(data) {
  console.log(data);
  const { oldIndex, newIndex } = data.moved;

  if (oldIndex === undefined || newIndex === undefined) return;

  const item = payRanges.value.splice(oldIndex, 1)[0];
  payRanges.value.splice(newIndex, 0, item);

  payRanges.value.forEach((item, index) => {
    item.order = index + 1;
  });
}

onMounted(async () => {
  proxy.$loader.show();
  proxy.$loader.hide();
});
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
</style>
